import { render } from '@verndale/core';
import Field from './components/Field';

const checkFields = () => {
  const fields = document.querySelectorAll('.field');
  render(fields, target => new Field(target));
};

export default checkFields;
